<template>
  <div class="md:px-12 text-gray-500">
    <h4 class="text-blue text-xl font-bold pb-6 md:pb-10">Finding Affordable Health Insurance in California</h4>
    <p class="text-left">The state of California offers a wide assortment of affordable health care insurance options. Find plans that give you and your family long-term coverage. Or, enroll in short-term plans for as little as one month. This can protect you from gaps in between insurance plans. With a variety of options, you can rest assured you’ll find a quality health plan that meets your needs.</p>
  </div>
</template>
